import React from 'react'

const CheckoutMembership = () => {
  return <div>CheckoutMembership</div>
}

export default CheckoutMembership
